import { render, staticRenderFns } from "./EditSaleRate.vue?vue&type=template&id=5af0b1ff"
import script from "./EditSaleRate.vue?vue&type=script&lang=js"
export * from "./EditSaleRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports